(function () {
  'use strict';

  var wurzel = document.querySelector('[data-okf]');
  if (!wurzel) return;
  var D = {};
  try { D = JSON.parse(wurzel.querySelector('[data-okf-daten]').textContent); } catch (e) { D = {}; }
  var T = D.texte || {};
  var PRESETS = D.presets || {}, KOMP = D.komp || {};

  function klar(s) {
    return s.replace(/&(amp|lt|gt|quot|#39);/g, function (m, x) { return { amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'" }[x]; });
  }
  function t(k, w) {
    var s = klar(String(T[k] || ''));
    for (var x in (w || {})) s = s.split('{' + x + '}').join(w[x]);
    return s;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function geld(n) {
    n = Number(n);
    if (!isFinite(n)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', {
        style: 'currency', currency: wurzel.getAttribute('data-okf-waehrung') || 'EUR',
        minimumFractionDigits: Math.round(n * 100) % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function rabattEuro(r, preis) {
    if (!r || !(Number(r.wert) > 0) || preis == null) return 0;
    return r.art === 'prozent' ? Math.round(preis * Number(r.wert)) / 100 : Number(r.wert);
  }

  var ANORD = [['single', 1], ['dual_horizontal', 2], ['dual_vertical', 2], ['triple_horizontal', 3],
               ['triple_pyramid', 3], ['quad_grid', 4], ['quad_pyramid', 4]];
  var AUFBAU = ['stange', 'stange_lang', 'basis'];
  var SYS = ['feder', 'gelenk', 'direkt'], GEL = ['2', '1', '0'], KOEPFE = ['standard', 'slider'];
  var MITTE = ['center', 'top', 'bottom'];
  function anzahl(a) { var x = ANORD.filter(function (y) { return y[0] === a; })[0]; return x ? x[1] : 0; }
  function armVon(sys, gel) { return (sys === 'direkt' || gel === '0') ? 'direkt' : sys + gel; }
  function armSchluessel(sy, au) {
    if (au === 'direct') return 'direkt';
    var s = sy === 'mechanical_spring' ? 'feder' : sy === 'articulating' ? 'gelenk' : null;
    var g = au === 'two_joint' ? '2' : au === 'one_joint' ? '1' : null;
    return s && g ? s + g : null;
  }

  var K = {}, ALLE = {}, ZWANG = null;
  var ZOLL_MAX = 40, KG_MAX = 12;

  function zollAus(text) {
    var m = String(text || '').match(/(\d+(?:[.,]\d+)?)\D*$/);
    return m ? Math.min(ZOLL_MAX, parseFloat(m[1].replace(',', '.'))) : null;
  }
  (((D.paket || {}).kombinationen) || []).forEach(function (r) {
    var pos = r.positionen || {}, namen = Object.keys(pos);
    if (!namen.length) return;
    var alleDirekt = namen.every(function (p) { return pos[p].ausladung === 'direct'; });
    var mitte = alleDirekt ? [] : namen.filter(function (p) {
      return MITTE.indexOf(p) >= 0 && pos[p].ausladung === 'direct' && namen.length > 1;
    });
    var arme = namen.filter(function (p) { return mitte.indexOf(p) < 0; });
    var sk = {}, ko = {}, km = {};
    arme.forEach(function (p) { sk[armSchluessel(pos[p].arm, pos[p].ausladung)] = 1; ko[pos[p].kopf] = 1; });
    mitte.forEach(function (p) { km[pos[p].kopf] = 1; });
    if (Object.keys(sk).length !== 1 || Object.keys(ko).length !== 1 || Object.keys(km).length > 1) return;
    var arm = Object.keys(sk)[0], kopf = Object.keys(ko)[0];
    if (!arm || arm === 'null' || KOEPFE.indexOf(kopf) < 0) return;
    var aufbau = r.aufbau === 'nopole' ? 'basis' : (r.stange === 'extended' ? 'stange_lang' : 'stange');
    var umbau = !r.preset && !!r.gleiches_set, psku = r.preset || r.gleiches_set || null;
    var pr = psku ? (PRESETS[psku] || null) : null;
    var c = {
      code: r.code, preset: psku, umbau: umbau, anord: r.anordnung, aufbau: aufbau, arm: arm, kopf: kopf,
      mitte: mitte, kopf_mitte: Object.keys(km)[0] || null, stueckliste: r.stueckliste || {},
      archiv: !!(psku && pr === null),
      zoll: pr && !umbau ? zollAus(pr.zoll) : (r.preset ? null : (r.zoll_max ? Math.min(ZOLL_MAX, r.zoll_max) : null)),
      kg_text: pr ? (pr.kg || '') : '',
      tisch: r.tisch_mm || null,
      kg: r.kg && r.kg[1] ? [r.kg[0], Math.min(KG_MAX, r.kg[1])] : null,
      kg_gebogen: pr ? kgZahl(pr.kg_gebogen) : (r.kg_gebogen && r.kg_gebogen[1] ? Math.min(KG_MAX, Number(r.kg_gebogen[1])) : null),
      bild: pr && !umbau ? pr.bild : ((D.konfbilder || {})[r.code] || ''),
      bildname: pr && !umbau ? pr.bildname : ((D.konfbilder || {})[r.code] ? 'one-aufbau-' + r.code + '.png' : '')
    };
    if (!anzahl(c.anord)) return;
    ALLE[c.code] = c;
    var schl = [c.anord, c.aufbau, c.arm, c.kopf].join('|');
    var alt = K[schl];
    if (alt && (alt.preset || (!c.preset && alt.mitte.length <= c.mitte.length))) return;
    K[schl] = c;
  });

  function alle(f) { return Object.keys(K).map(function (k) { return K[k]; }).filter(f); }
  function roh(st) { return K[[st.a, st.b, armVon(st.sys, st.gel), st.k].join('|')] || null; }
  function stVon(c) {
    var a = c.arm;
    return { n: anzahl(c.anord), a: c.anord, b: c.aufbau,
             sys: a === 'direkt' ? 'direkt' : a.replace(/[12]$/, ''), gel: a === 'direkt' ? '0' : a.slice(-1), k: c.kopf };
  }

  function presetWeg(c) {
    if (!c.preset) return false;
    var p = PRESETS[c.preset];
    return !p || (!p.da && !p.termin);
  }
  function preis(c) {
    if (c.preset && PRESETS[c.preset]) { var p = PRESETS[c.preset], pr = p.preis / 100; return pr - rabattEuro(p.rabatt, pr); }
    var s = 0;
    for (var tl in c.stueckliste) {
      var k = KOMP[tl]; if (!k) continue;
      s += (k.preis / 100 - rabattEuro(k.rabatt, k.preis / 100)) * c.stueckliste[tl];
    }
    return s;
  }

  var ARB = { mon: [] }, monDaten = {};
  function proxy() { return (window.FinderClean && window.FinderClean.proxy) || wurzel.getAttribute('data-okf-proxy-fallback') || '/apps/monitor-db'; }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function arbeitsplatzLesen() {
    var a = {};
    try { a = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; } catch (e) {}
    var refs = (a.refs || []).map(String);
    var offen = refs.filter(function (r) { return !monDaten[r]; });
    ARB.mon = refs.map(function (r) { return monDaten[r] || { zoll: 0, kg: 0 }; });
    ARB.tisch_mm = a.tisch && Number(a.tisch.dicke_cm) > 0 ? Math.round(Number(a.tisch.dicke_cm) * 10) : 0;
    if (offen.length) {
      Promise.all(offen.map(function (r) {
        return abruf(proxy() + '/monitors/' + encodeURIComponent(r)).then(function (j) {
          var d = (j && j.ok && j.data) || {};
          monDaten[r] = { zoll: Number(d.size_inch) || 0, kg: (Number(d.weight_g) || 0) / 1000 };
        }).catch(function () { monDaten[r] = { zoll: 0, kg: 0 }; });
      })).then(function () { arbeitsplatzLesen(); neu(); });
    }
  }
  function kgZahl(txt) { var m = String(txt || '').match(/(\d+(?:[.,]\d+)?)\s*kg/); return m ? Number(m[1].replace(',', '.')) : null; }
  function gebogenZusatz(c) {
    var g = c.kg_gebogen, f = kgMax(c);
    if (!g || !f || g >= f) return '';
    return '<span class="okf__pt"> · </span><span>' + esc(t('gebogen')) + ' ' + esc(t('max')) + '</span> <b>' + esc(String(g).replace('.', ',')) + ' kg</b>';
  }
  function kgMax(c) {
    if (c.kg && c.kg[1]) return Math.min(KG_MAX, Number(c.kg[1]));
    var m = String(c.kg_text || '').match(/(\d+(?:[.,]\d+)?)\s*kg/);
    return m ? Math.min(KG_MAX, parseFloat(m[1].replace(',', '.'))) : null;
  }
  function kgMin(c) {
    if (c.kg && Number(c.kg[0]) > 0) return Number(c.kg[0]);
    var m = String(c.kg_text || '').match(/^\s*(\d+(?:[.,]\d+)?)\s*(?:kg)?\s*[-–]/);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }
  function passtGrund(c) {
    if (!ARB.mon.length) return '';
    if (anzahl(c.anord) !== ARB.mon.length) return ARB.mon.length > 1 ? t('grund_plaetze_n', { n: ARB.mon.length }) : t('grund_plaetze_1');
    return passtGroesse(c);
  }
  function passtGroesse(c) {
    if (!ARB.mon.length) return '';
    var gr = Math.max.apply(null, ARB.mon.map(function (m) { return m.zoll; }));
    var kg = Math.max.apply(null, ARB.mon.map(function (m) { return m.kg; }));
    if (c.zoll && gr > c.zoll + 0.4) return t('grund_zoll');
    var km = kgMax(c);
    if (km && kg > km) return t('grund_kg');
    var kl = Math.min.apply(null, ARB.mon.map(function (m) { return m.kg || Infinity; }));
    var kn = kgMin(c);
    if (kn && isFinite(kl) && kl < kn) return t('grund_kg_min');
    return '';
  }
  function ok(c) { return !!c && !presetWeg(c) && !passtGrund(c); }

  function gross(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function grund(st) {
    var arm = armVon(st.sys, st.gel), c = roh(st), A = t('g_' + st.a);
    if (c && presetWeg(c)) return t('grund_verfuegbar');
    if (c) { var g = passtGrund(c); if (g) return g; }
    var L = alle(function (x) { return x.anord === st.a && !presetWeg(x); });
    if (!L.length) return t('grund_allgemein');
    var La = L.filter(function (x) { return x.arm === arm; });
    if (!La.length) {
      if (arm === 'direkt') return gross(t('grund_arm', { A: A }));
      var sys = arm.replace(/[12]$/, '');
      var gleich = L.filter(function (x) { return x.arm !== 'direkt' && x.arm.replace(/[12]$/, '') === sys; });
      if (gleich.length) {
        var n = gleich[0].arm.slice(-1);
        return gross(t('grund_gelenke', { A: A, n: n === '1' ? t('gelenke_1') : t('gelenke_n', { n: n }) }));
      }
      var anders = L.filter(function (x) { return x.arm !== 'direkt'; })[0];
      if (anders) return gross(t('grund_system', { A: A, S: t(anders.arm.indexOf('feder') === 0 ? 'sys_feder' : 'sys_gelenk') }));
      return t('grund_allgemein');
    }
    var Lk = La.filter(function (x) { return x.kopf === st.k; });
    if (!Lk.length && /1$/.test(arm) && st.k === 'standard' && La[0].kopf === 'slider'
        && (st.a === 'dual_horizontal' || st.a === 'quad_grid')) return t('grund_kopf_1gelenk');
    if (!Lk.length) return gross(t('grund_kopf', { A: A, K: La[0].kopf === 'slider' ? t('kopf_slider') : t('standardkopf') }));
    var auf = Lk.map(function (x) { return x.aufbau; });
    if (auf.indexOf(st.b) < 0) {
      if (st.b === 'basis') return gross(t('grund_stange', { A: A }));
      if (auf.indexOf('stange_lang') >= 0 && st.b === 'stange') return gross(t('grund_lang', { A: A }));
      if (auf.indexOf('stange') >= 0 && st.b === 'stange_lang') return gross(t('grund_kurz', { A: A }));
      if (auf.indexOf('basis') >= 0) return gross(t('grund_basis', { A: A }));
    }
    return t('grund_allgemein');
  }
  function naechste(st) {
    var l = alle(ok);
    if (!l.length) return null;
    var arm = armVon(st.sys, st.gel);
    function sc(c) {
      return (c.anord === st.a ? 16 : 0) + (c.arm === arm ? 8 : 0) + (c.aufbau === st.b ? 4 : 0)
        + (c.kopf === st.k ? 2 : 0) + (anzahl(c.anord) === st.n ? 1 : 0);
    }
    return l.sort(function (x, y) { return sc(y) - sc(x) || (x.preset ? 0 : 1) - (y.preset ? 0 : 1) || preis(x) - preis(y); })[0];
  }
  function armName(arm) {
    if (arm === 'direkt') return t('sys_direkt');
    return t('sys_' + arm.replace(/[12]$/, '')) + ' · ' + t('gel_' + arm.slice(-1));
  }
  function name(c) {
    var n = anzahl(c.anord), k = T['k_' + c.anord] || '';
    var s = (n > 1 ? t('monitor_n', { n: n }) : t('monitor_1')) + (k ? ' ' + k : '');
    return '3IDEE® ONE · ' + s + ' · ' + armName(c.arm) + (c.kopf === 'slider' ? ' · ' + t('kopf_slider') : '')
      + (c.mitte && c.mitte.length ? ' · ' + t('mitte_direkt')
         + (c.kopf_mitte && c.kopf_mitte !== c.kopf ? ' ' + t('mit') + ' ' + (c.kopf_mitte === 'slider' ? t('kopf_slider') : t('standardkopf')) : '') : '')
      + (c.aufbau === 'basis' ? ' · ' + t('b_basis') : '');
  }
  function setze(st, f, w) {
    var x = Object.assign({}, st); x[f] = w;
    if (f === 'n' && anzahl(x.a) !== w) x.a = ANORD.filter(function (y) { return y[1] === w; })[0][0];
    if (f === 'a') x.n = anzahl(w);
    if (f === 'sys' && w === 'direkt') x.gel = '0';
    if (f === 'sys' && w !== 'direkt' && x.gel === '0') x.gel = '2';
    if (f === 'gel' && w === '0') x.sys = 'direkt';
    if (f === 'gel' && w !== '0' && x.sys === 'direkt') x.sys = 'feder';
    return x;
  }

  var PIKTO = { single: [[22, 10]], dual_horizontal: [[10, 10], [34, 10]], dual_vertical: [[22, 4], [22, 17]],
    triple_horizontal: [[4, 10], [22, 10], [40, 10]], triple_pyramid: [[22, 3], [10, 17], [34, 17]],
    quad_grid: [[10, 4], [34, 4], [10, 17], [34, 17]], quad_pyramid: [[22, 1], [8, 11], [36, 11], [22, 21]] };
  function pikto(a) {
    return '<svg viewBox="-1 0 60 32" aria-hidden="true">' + PIKTO[a].map(function (p) {
      return '<rect x="' + (p[0] - 1) + '" y="' + p[1] + '" width="18" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.6"/>';
    }).join('') + '</svg>';
  }
  function delta(x) {
    if (Math.abs(x) < 0.005) return t('gleich');
    return (x > 0 ? '+ ' : '– ') + geld(Math.abs(x)).replace(/[.,]00(?=\D*$)/, '');
  }
  var ST = null, OFFEN = null, VORHER_OFFEN = null;
  var HINWEIS = null;
  function handy() { return !!(window.matchMedia && matchMedia('(max-width: 1023px)').matches); }
  function kgText(c) {
    var k = c.kg_text || (c.kg && c.kg[1] ? (c.kg[0] ? c.kg[0] + '–' : t('bis') + ' ') + c.kg[1] + ' kg' : '');
    return k.replace(/\./g, ',');
  }
  function schluessel(c) { return [c.anord, c.aufbau, c.arm, c.kopf].join('|'); }
  function grenzHinweis(a, b) {
    if (!a || !b || a === b) return [];
    var z = [], mk = function (x) { return '\u0001' + x + '\u0002'; }, zl = function (x) { return String(x).replace('.', ',') + '″'; };
    if (a.zoll && b.zoll && b.zoll < a.zoll - 0.4) z.push(['wh_zoll', { neu: mk(zl(b.zoll)), alt: zl(a.zoll) }]);
    var ka = kgMax(a), kb = kgMax(b), na = kgMin(a) || 0, nb = kgMin(b) || 0;
    if ((ka && kb && kb < ka) || nb > na) z.push(['wh_kg', { neu: mk(kgText(b)), alt: kgText(a) }]);
    var ta = a.tisch || [], tb = b.tisch || [];
    if (ta[1] && tb[1] && (tb[1] < ta[1] || (tb[0] || 0) > (ta[0] || 0))) z.push(['wh_tisch', { neu: mk(tb[0] + '–' + tb[1] + ' mm'), alt: ta[0] + '–' + ta[1] + ' mm' }]);
    if (!z.length) return [];
    try {
      var sk = 'okf-hw:' + schluessel(a) + '>' + schluessel(b);
      if (sessionStorage.getItem(sk)) return [];
      sessionStorage.setItem(sk, '1');
    } catch (e) {}
    return z.map(function (x) { return esc(t(x[0], x[1])).replace(/\u0001/g, '<b>').replace(/\u0002/g, '</b>'); });
  }
  function hinweisHtml(wo) {
    var h = HINWEIS;
    if (!h || h.wo !== wo || (!h.leise && !h.werte.length)) return '';
    return '<div class="okf__hw" role="status">'
      + (h.leise ? '<p class="okf__hinweis">' + esc(h.leise) + '</p>' : '')
      + (h.werte.length ? '<div class="okf__wh"><span class="okf__wh-i" aria-hidden="true">i</span><div>'
        + h.werte.map(function (x) { return '<p class="okf__wh-z">' + x + '</p>'; }).join('')
        + (h.passt ? '<p class="okf__wh-passt">' + esc(h.passt) + '</p>' : '') + '</div></div>' : '')
      + '</div>';
  }
  var START_FEST = true;
  function hatWert(c, f, w) {
    var a = c.arm, sys = a === 'direkt' ? 'direkt' : a.replace(/[12]$/, ''), gel = a === 'direkt' ? '0' : a.slice(-1);
    return f === 'n' ? anzahl(c.anord) === w : f === 'a' ? c.anord === w : f === 'b' ? c.aufbau === w
      : f === 'sys' ? sys === w : f === 'gel' ? gel === w : f === 'k' ? c.kopf === w : false;
  }
  function besteMit(st, f, w) {
    var x = setze(st, f, w), arm = armVon(x.sys, x.gel);
    var l = alle(function (c) { return ok(c) && hatWert(c, f, w) && (f === 'n' || f === 'a' || c.anord === st.a); });
    if (!l.length) return null;
    function sc(c) {
      return (c.anord === x.a ? 16 : 0) + (c.arm === arm ? 8 : 0) + (c.aufbau === x.b ? 4 : 0) + (c.kopf === x.k ? 2 : 0) + (anzahl(c.anord) === x.n ? 1 : 0);
    }
    return l.sort(function (p, q) { return sc(q) - sc(p) || (p.preset ? 0 : 1) - (q.preset ? 0 : 1) || preis(p) - preis(q); })[0];
  }
  function zustand(f, w) {
    var x = setze(ST, f, w), an = ST[f] === w, gut = ok(roh(x)) || !!besteMit(ST, f, w);
    return { an: an, attr: ' data-f="' + f + '" data-w="' + w + '"' + (!an && !gut ? ' aria-disabled="true"' : '') };
  }
  function taste(f, w, titel, unter) {
    var z = zustand(f, w);
    return '<button type="button" class="okf__taste' + (z.an ? ' is-an' : '') + '"' + z.attr + ' aria-pressed="' + z.an + '">'
      + '<span class="okf__tt">' + esc(titel) + '</span>' + (unter ? '<span class="okf__tu">' + esc(unter) + '</span>' : '') + '</button>';
  }
  function sv(inner, vb) {
    return '<svg viewBox="' + (vb || '0 0 56 32') + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>';
  }
  var RASTER = { single: [[0, 0]], dual_horizontal: [[0, 0], [1, 0]], dual_vertical: [[0, 0], [0, 1]], triple_horizontal: [[0, 0], [1, 0], [2, 0]],
    quad_grid: [[0, 0], [1, 0], [0, 1], [1, 1]], triple_pyramid: [[0.5, 0], [0, 1], [1, 1]], quad_pyramid: [[0.5, 0], [0, 1], [1, 1], [0.5, 2]] };
  function piktoKarte(a) {
    var z = RASTER[a] || RASTER.single, bx = 0, by = 0;
    z.forEach(function (p) { bx = Math.max(bx, p[0] + 1); by = Math.max(by, p[1] + 1); });
    var gw = bx * 16 + (bx - 1) * 4, gh = by * 10 + (by - 1) * 4, x0 = (64 - gw) / 2, y0 = (40 - gh) / 2;
    return sv(z.map(function (p) { return '<rect x="' + (x0 + p[0] * 20) + '" y="' + (y0 + p[1] * 14) + '" width="16" height="10" rx="1.5"/>'; }).join(''), '0 0 64 40');
  }
  function piktoAufbau(b) {
    var arme = function (y) { return '<line x1="16" y1="' + y + '" x2="40" y2="' + y + '"/><rect x="12" y="' + (y - 4) + '" width="4" height="8" rx="1"/><rect x="40" y="' + (y - 4) + '" width="4" height="8" rx="1"/>'; };
    if (b === 'basis') return sv('<rect x="17" y="25" width="22" height="4" rx="1.5"/><line x1="28" y1="25" x2="28" y2="19"/>' + arme(19));
    if (b === 'stange_lang') return sv('<line x1="28" y1="29" x2="28" y2="2"/><line x1="23" y1="29" x2="33" y2="29"/>' + arme(6));
    return sv('<line x1="28" y1="29" x2="28" y2="10"/><line x1="23" y1="29" x2="33" y2="29"/>' + arme(12));
  }
  function piktoArm(a) {
    var stange = '<line x1="8" y1="30" x2="8" y2="4"/><line x1="4" y1="30" x2="13" y2="30"/>',
      kopf = function (x, y) { return '<rect x="' + x + '" y="' + (y - 6) + '" width="3.5" height="12" rx="1"/>'; },
      gel = function (x, y) { return '<circle cx="' + x + '" cy="' + y + '" r="1.7"/>'; },
      feder = function (x1, y1, x2, y2) { return '<line x1="' + x1 + '" y1="' + (y1 - 1.6) + '" x2="' + x2 + '" y2="' + (y2 - 1.6) + '"/><line x1="' + x1 + '" y1="' + (y1 + 1.6) + '" x2="' + x2 + '" y2="' + (y2 + 1.6) + '"/>'; };
    if (a === 'direkt') return sv(stange + '<line x1="8" y1="11" x2="11" y2="11"/>' + kopf(11, 11));
    if (a === 'feder2') return sv(stange + feder(8, 11, 27, 16) + gel(27, 16) + '<line x1="27" y1="16" x2="44" y2="11"/>' + gel(44, 11) + kopf(46, 11));
    if (a === 'gelenk2') return sv(stange + '<line x1="8" y1="11" x2="27" y2="16"/>' + gel(8, 11) + gel(27, 16) + '<line x1="27" y1="16" x2="44" y2="11"/>' + gel(44, 11) + kopf(46, 11));
    if (a === 'feder1') return sv(stange + feder(8, 11, 38, 11) + gel(38, 11) + kopf(40, 11));
    return sv(stange + '<line x1="8" y1="11" x2="38" y2="11"/>' + gel(8, 11) + gel(38, 11) + kopf(40, 11));
  }
  function karte(f, w, name, bild) {
    var z = zustand(f, w);
    return '<button type="button" class="okf__karte' + (z.an ? ' is-an' : '') + '"' + z.attr + ' aria-pressed="' + z.an + '"'
      + ' aria-label="' + esc(name) + '" title="' + esc(name) + '">'
      + '<span class="okf__haken" aria-hidden="true"></span><span class="okf__bildfeld">' + bild + '</span></button>';
  }
  function reiter(f, w, label) {
    var z = zustand(f, w);
    return '<button type="button" role="tab" class="okf__reiter' + (z.an ? ' is-an' : '') + '"' + z.attr + ' aria-selected="' + z.an + '">' + esc(label) + '</button>';
  }
  function umschalter(inhalt, n) { return '<div class="okf__wahl" style="--okf-sp:' + n + '">' + inhalt + '</div>'; }
  function reiterzeile(inhalt, titel) { return '<div class="okf__reiterzeile" role="tablist" aria-label="' + esc(titel) + '">' + inhalt + '</div>'; }
  function unterpunkt(titel, inhalt) { return '<div class="okf__up"><p class="okf__ut">' + esc(titel) + '</p>' + inhalt + '</div>'; }

  function schritt(nr, titel, wert, inhalt, id) {
    var auf = OFFEN === id, war = VORHER_OFFEN === id;
    return '<div class="okf__schritt' + (auf ? ' is-auf' : '') + (war ? ' is-dreh' : '') + '" data-schritt="' + id + '">'
      + '<button type="button" class="okf__s-kopf" data-auf="' + id + '" aria-expanded="' + auf + '"'
      + (auf ? ' aria-controls="okf-s-' + id + '"' : '') + ' aria-label="' + esc(titel + ': ' + wert + ' – ' + t('aendern')) + '">'
      + '<span class="okf__s-p" aria-hidden="true">' + nr + '</span><span class="okf__s-tx"><span class="okf__s-t">' + esc(titel) + '</span><span class="okf__s-w">' + esc(wert) + '</span></span>'
      + '<span class="svg-wrapper icon-caret icon-animated okf__pf" aria-hidden="true">' + (D.caret || '') + '</span></button>'
      + (auf ? '<div class="okf__s-in" id="okf-s-' + id + '">' + inhalt + '</div>' : '') + '</div>';
  }

  function aehnlich(c) {
    var l = alle(function (x) { return x.bild && x.anord === c.anord && x.aufbau === c.aufbau; });
    l.sort(function (a, b) { return (a.arm.slice(0, 5) === c.arm.slice(0, 5) ? 0 : 1) - (b.arm.slice(0, 5) === c.arm.slice(0, 5) ? 0 : 1); });
    return l[0] || null;
  }
  function faktZeile(c, bildC) {
    var info = bildC && KOPFPOS[bildC.bildname];
    if (!info || !info.k.length || !c.zoll) return fakten(c);
    var kg = kgMax(c);
    return kg ? '<div class="okf__bildfakt okf__bildfakt--klein"><span>' + esc(t('max')) + '</span> <b>' + esc(String(kg).replace('.', ',')) + ' kg</b> <span>'
      + esc(t('je_monitor')) + '</span>' + gebogenZusatz(c) + '</div>' : '';
  }
  function fakten(c) {
    var teile = [];
    if (c.zoll) teile.push('<span>' + esc(t('bis')) + '</span> <b>' + esc(String(c.zoll).replace('.', ',')) + '″</b>');
    var kg = c.kg_text || '';
    if (!kg && c.kg && c.kg[1]) kg = (c.kg[0] ? String(c.kg[0]).replace('.', ',') + '–' : t('bis') + ' ') + String(c.kg[1]).replace('.', ',') + ' kg';
    if (kg) {
      var b = t('bis') + ' ';
      teile.push((kg.indexOf(b) === 0 ? '<span>' + esc(t('bis')) + '</span> <b>' + esc(kg.slice(b.length)) + '</b> <span>' + esc(t('je_monitor')) + '</span>'
                                      : '<b>' + esc(kg) + '</b> <span>' + esc(t('je_monitor')) + '</span>') + gebogenZusatz(c));
    }
    return teile.length ? '<div class="okf__bildfakt">' + teile.join('<span class="okf__pt"> · </span>') + '</div>' : '';
  }

  var S_MM = 1.225, MITTE_X = 849;
  var KOPFPOS = {
    'one-aufbau-fg-d1.png': { w: 1698, h: 966, o: 103, a: 933, p: 947, t: 832, k: [[1560, 164], [124, 168]] },
    'one-aufbau-fg-d2s.png': { w: 1698, h: 966, o: 91, a: 923, p: 947, t: 825, k: [[136, 160], [1548, 160]] },
    'one-aufbau-fg-s1.png': { w: 1698, h: 966, o: 14, a: 928, p: 947, t: 829, k: [[880, 76]] },
    'one-aufbau-fg-t1.png': { w: 1698, h: 966, o: 110, a: 933, p: 947, t: 834, k: [[136, 180], [1548, 180], [844, 364]] },
    'one-aufbau-fg-t2s.png': { w: 1698, h: 966, o: 88, a: 924, p: 947, t: 824, k: [[132, 156], [1552, 156], [840, 356]] },
    'one-aufbau-fga-d1.png': { w: 1698, h: 966, o: 225, a: 927, p: 947, t: 828, k: [[188, 288], [1500, 292]] },
    'one-aufbau-fga-d2s.png': { w: 1698, h: 966, o: 204, a: 927, p: 947, t: 827, k: [[172, 268], [1508, 268]] },
    'one-aufbau-fga-s0.png': { w: 1698, h: 966, o: 276, a: 923, p: 947, t: 825, k: [[836, 340]] },
    'one-aufbau-fg-s2s.png': { w: 1698, h: 966, o: 135, a: 922, p: 941, t: 826, k: [[418, 208], [1272, 208]] },
    'one-aufbau-fga-s1.png': { w: 1698, h: 966, o: 156, a: 924, p: 947, t: 824, k: [[932, 220]] },
    'one-aufbau-fgf-s1.png': { w: 1698, h: 966, o: 199, a: 905, p: 924, frontal: false, t: 874, k: [] },
    'one-aufbau-fgf-s2.png': { w: 1698, h: 966, o: 236, a: 914, p: 933, t: 833, k: [[241, 284], [1456, 306]] },
    'one-aufbau-fg-q1.png': { w: 1698, h: 1343, o: 13, a: 1304, p: 1324, t: 1205, k: [[133, 86], [1565, 86], [133, 547], [1565, 547]] },
    'one-aufbau-fg-q2s.png': { w: 1698, h: 1345, o: 13, a: 1306, p: 1326, t: 1207, k: [[144, 86], [1558, 86], [144, 547], [1558, 547]] },
    'one-aufbau-cmb_86xwwu9.png': {w: 1698, h: 966, o: 204, a: 927, p: 947, t: 828, k: [[521,276], [1177,277]]},
    'one-aufbau-cmb_eds6wk2.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[848,238], [848,854]]},
    'one-aufbau-cmb_5jnqe2t.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[848,239], [940,855]]},
    'one-aufbau-cmb_h6s7uye.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[847,238], [847,855]]},
    'one-aufbau-cmb_etnzw4p.png': {w: 1698, h: 1288, o: 127, a: 1249, p: 1269, t: 1150, k: [[941,202], [941,818]]},
    'one-aufbau-cmb_hyna3eh.png': {w: 1698, h: 1288, o: 38, a: 1249, p: 1269, t: 1150, k: [[888,110], [888,726]]},
    'one-aufbau-cmb_c7ws8bx.png': {w: 1698, h: 966, o: 43, a: 927, p: 947, t: 828, k: [[849,115], [849,640]]},
    'one-aufbau-cmb_4mkuyzc.png': {w: 1698, h: 966, o: 169, a: 927, p: 947, t: 828, k: [[849,244], [849,585]]},
    'one-aufbau-cmb_82x22g8.png': {w: 1698, h: 966, o: 42, a: 927, p: 947, t: 828, k: [[849,115], [849,640]]},
    'one-aufbau-cmb_ep88mws.png': {w: 1698, h: 966, o: 170, a: 927, p: 947, t: 828, k: [[848,244], [848,585]]},
    'one-aufbau-cmb_8cb28re.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[849,354], [144,540], [1556,540], [849,727]]},
    'one-aufbau-cmb_rr6smvq.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[848,238], [192,854], [1504,855]]},
    'one-aufbau-cmb_ppcv5xx.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[848,238], [181,854], [1519,855]]},
    'one-aufbau-cmb_h77h26w.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[848,238], [92,856], [1606,854]]},
    'one-aufbau-cmb_aaha6ff.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[848,238], [106,854], [1595,855]]},
    'one-aufbau-cmb_f5qh7dw.png': {w: 1698, h: 1288, o: 44, a: 1249, p: 1269, t: 1150, k: [[888,116], [134,732], [1566,732]]},
    'one-aufbau-cmb_4zd7vcr.png': {w: 1698, h: 1288, o: 50, a: 1249, p: 1269, t: 1150, k: [[888,122], [144,738], [1556,738]]},
    'one-aufbau-cmb_femzxgt.png': {w: 1698, h: 1288, o: 131, a: 1249, p: 1269, t: 1150, k: [[192,202], [1504,202], [192,818], [1504,818]]},
    'one-aufbau-cmb_bdnc8ke.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[422,252], [1299,252], [422,792], [1299,792]]},
    'one-aufbau-cmb_vdxv7y8.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[521,544], [1177,545], [521,916], [1177,917]]},
    'one-aufbau-cmb_9tbbd2s.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[192,638], [1504,639], [848,452], [848,942]]},
    'one-aufbau-cmb_beumsp5.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[181,644], [1519,645], [848,458], [848,942]]},
    'one-aufbau-cmb_4273vv8.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[134,460], [1566,460], [848,274], [848,942]]},
    'one-aufbau-cmb_hr24zvs.png': {w: 1698, h: 1288, o: 117, a: 1249, p: 1269, t: 1150, k: [[120,608], [1587,608], [848,190], [848,1026]]},
    'one-aufbau-cmb_9ff49b6.png': {w: 1698, h: 1288, o: 145, a: 1249, p: 1269, t: 1150, k: [[134,540], [1566,540], [888,354], [888,727]]},
    'one-aufbau-cmb_gmrfg8j.png': {w: 1698, h: 966, o: 204, a: 927, p: 947, t: 827, k: [[172,268], [1508,268], [848,350]]}
  };
  window.oneKopfpos = KOPFPOS;
  function monMass(z) { var d = z * 25.4; return [d * 16 / Math.sqrt(337) * S_MM, d * 9 / Math.sqrt(337) * S_MM]; }
  function ueber(a, b) { return a[0] < b[0] + b[2] && b[0] < a[0] + a[2] && a[1] < b[1] + b[3] && b[1] < a[1] + a[3]; }
  function rahmen(k, zs, fs, zeichen, zeilen) {
    var cx = 0, cy = 0;
    k.forEach(function (q) { cx += q[0]; cy += q[1]; }); cx /= k.length; cy /= k.length;
    var R = k.map(function (p, i) { var wh = monMass(zs[i]); return { p: p, z: zs[i], x: p[0] - wh[0] / 2, y: p[1] - wh[1] / 2, w: wh[0], h: wh[1] }; });
    R.forEach(function (a, i) {
      R.forEach(function (b, j) {
        if (j <= i || Math.abs(a.p[1] - b.p[1]) > Math.min(a.h, b.h) / 2) return;
        var l = a.p[0] < b.p[0] ? a : b, r = l === a ? b : a;
        var ueber = l.x + l.w + 5 * S_MM - r.x;
        if (ueber > 0) { l.x -= ueber / 2; r.x += ueber / 2; }
      });
    });
    var belegt = [];
    R.forEach(function (r, i) {
      var lw = fs * ((zeichen || String(r.z).length) * 0.56 + 0.55), lh = fs * 1.05 * (zeilen || 1), g = fs * 0.3;
      var mittig = k.length > 2 && Math.abs(r.p[0] - cx) <= 50, li = !mittig && r.p[0] < cx - 50;
      var ax = mittig ? r.x + (r.w - lw) / 2 : li ? r.x : r.x + r.w - lw, an = mittig ? 'middle' : li ? 'start' : 'end',
          tx = mittig ? r.x + r.w / 2 : li ? r.x : r.x + r.w;
      var oben = [ax, r.y - g - lh, lw, lh, an, tx, r.y - g - lh * 0.18], unten = [ax, r.y + r.h + g, lw, lh, an, tx, r.y + r.h + g + lh * 0.82],
          rechts = [r.x + r.w + g, r.y, lw, lh, 'start', r.x + r.w + g, r.y + lh * 0.82], links = [r.x - g - lw, r.y, lw, lh, 'end', r.x - g, r.y + lh * 0.82];
      var wahl = mittig ? [oben, unten, r.p[0] < cx ? links : rechts, r.p[0] < cx ? rechts : links]
        : r.p[1] < cy - 50 ? [oben, rechts, links, unten] : r.p[1] > cy + 50 ? [unten, rechts, links, oben]
        : [oben, unten, r.p[0] < cx ? links : rechts, r.p[0] < cx ? rechts : links];
      var frei = wahl.filter(function (c) {
        var b = c.slice(0, 4);
        return !R.some(function (o, j) { return j !== i && ueber(b, [o.x, o.y, o.w, o.h]); }) && !belegt.some(function (o) { return ueber(b, o); });
      })[0] || wahl[0];
      r.lab = frei; belegt.push(frei.slice(0, 4));
    });
    return R;
  }

  var LETZT_ZOLL = null, PULS = false, SVG_ID = 0, GROSS = false;
  function tischArt() {
    try { var a = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; return a.tisch && a.tisch.gruppe === 'glas' ? 'glas' : 'holz'; }
    catch (e) { return 'holz'; }
  }
  function buehneSvg(c, bildC, B, H) {
    var info = bildC && KOPFPOS[bildC.bildname];
    if (!info || !(B > 0) || !(H > 0)) return null;
    var schmal = B < 560;
    var szenen = D.szenen || {}, sz = info.frontal === false ? null : (szenen[tischArt()] || szenen.holz || null);
    var A = info.a, zs = c.zoll && info.k.length ? info.k.map(function () { return c.zoll; }) : [];
    var oben = schmal ? 40 : 56, seite = schmal ? 14 : 28;
    var F = 300, K = 28, S = 80;
    var unterH = H * (schmal ? 0.2 : 0.18), kk = 0, streifen = 0, platteOben = 0, boden = 0;
    var kgM = kgMax(c), mitKg = !!kgM && (!schmal || GROSS), zwei = function () { return schmal && mitKg; };
    var kgText = kgM ? t('max') + ' ' + String(kgM).replace('.', ',') + ' kg' : '';
    var lab = function (z) {
      var zt = t('max') + ' ' + z + '″';
      if (!mitKg) return zt;
      return zwei() ? (zt.length > kgText.length ? zt : kgText) : zt + ' · ' + kgText;
    };
    var g, R, fs, y0, hw;
    function rechne() {
    g = (B * 0.84) / (2 * (MITTE_X + 60)); R = []; fs = 0; y0 = info.o; hw = MITTE_X + 60;
    for (var it = 0; it < 4; it++) {
      if (sz) {
        kk = (sz.mm * S_MM * g) / (sz.u - sz.s);
        streifen = (sz.u - sz.o) * kk;
        if (GROSS && it > 0) unterH = Math.max(H * 0.2, H - streifen - (H + (A - y0) * g) / 2);
        platteOben = Math.round(H - unterH - streifen);
        boden = Math.round(platteOben + 0.02 * (sz.s - sz.o) * kk);
      }
      fs = (schmal ? 13 : 14) / g;
      R = zs.length ? rahmen(info.k, zs, fs, lab(zs[0]).length, zwei() ? 2.1 : 1) : [];
      hw = MITTE_X + 60; y0 = info.o;
      R.forEach(function (q) { [[q.x, q.y, q.w, q.h], q.lab].forEach(function (b) {
        y0 = Math.min(y0, b[1]); hw = Math.max(hw, Math.abs(b[0] - MITTE_X) + 10, Math.abs(b[0] + b[2] - MITTE_X) + 10); }); });
      g = sz ? Math.min(B * 0.84 / (2 * hw), (boden - 0.07 * H) / (A - y0))
             : Math.min((B - 2 * seite) / (2 * hw), (H - oben - 24) / (A + F + K + S - y0));
    }
    }
    rechne();
    if (schmal && mitKg && R.some(function (q) { return fs * (lab(q.z).length * 0.56 + 0.55) > q.w; })) { mitKg = false; rechne(); }
    var Vw = B / g, Vh = H / g, Vx = MITTE_X - Vw / 2, Vy, fy, px = 1 / g, id = 'okfb' + (++SVG_ID), hinten = '', vorn = '';
    var clip = '<clipPath id="' + id + 'c"><rect x="0" y="0" width="' + info.w + '" height="' + A + '"/></clipPath>';
    if (sz) {
      Vy = A - boden / g;
      var bild = function (vb, y, h, par) {
        return '<svg x="0" y="' + y + '" width="' + B + '" height="' + h + '" viewBox="' + vb + '" preserveAspectRatio="' + par + '">'
          + '<image href="' + esc(sz.bild) + '" width="' + sz.w + '" height="' + sz.h + '"/></svg>';
      };
      hinten = '<svg x="' + Vx + '" y="' + Vy + '" width="' + Vw + '" height="' + Vh + '" viewBox="0 0 ' + B + ' ' + H + '">'
        + bild('0 0 ' + sz.w + ' ' + sz.o, 0, platteOben + 1, 'xMidYMax slice')
        + bild('0 ' + sz.o + ' ' + sz.w + ' ' + (sz.u - sz.o), platteOben, streifen, 'none')
        + bild('0 ' + sz.u + ' ' + sz.w + ' ' + (sz.h - sz.u), platteOben + streifen - 0.5, H - platteOben - streifen + 1, 'xMidYMin slice')
        + '</svg>'
        + '<ellipse cx="' + MITTE_X + '" cy="' + (A + 2 * px) + '" rx="99" ry="' + Math.max(6, 5 * px) + '" fill="#000" fill-opacity=".35" filter="url(#' + id + 'b)"/>';
      fy = platteOben + streifen + (unterH - 24) / 2;
    } else {
      var hoch = (A + F + K + S - y0) * g;
      Vy = y0 - (oben + Math.max(0, H - oben - 24 - hoch) / 2) / g;
      var X0 = Vx - 4 * px, XW = Vw + 8 * px, VK = A + F;
      vorn = '<rect x="' + X0 + '" y="' + A + '" width="' + XW + '" height="' + F + '" fill="url(#' + id + 'o)"/>'
        + '<rect x="' + X0 + '" y="' + (A - px) + '" width="' + XW + '" height="' + (2 * px) + '" fill="#CFD0CC"/>'
        + '<ellipse cx="' + MITTE_X + '" cy="' + (A + 4) + '" rx="120" ry="9" fill="url(#' + id + 'k)"/>'
        + '<rect x="' + X0 + '" y="' + VK + '" width="' + XW + '" height="' + K + '" fill="#D9DAD6"/>'
        + '<rect x="' + X0 + '" y="' + VK + '" width="' + XW + '" height="' + (2 * px) + '" fill="#FFFFFF" fill-opacity=".9"/>'
        + '<rect x="' + X0 + '" y="' + (VK + K) + '" width="' + XW + '" height="' + S + '" fill="url(#' + id + 's)"/>';
      fy = (A + 130 - Vy) * g;
    }
    var defs = '<defs>' + clip
      + '<filter id="' + id + 'b" x="-50%" y="-200%" width="200%" height="500%"><feGaussianBlur stdDeviation="' + (4 * px) + '"/></filter>'
      + '<linearGradient id="' + id + 'o" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#E2E3E0"/><stop offset=".35" stop-color="#EFEFEC"/><stop offset="1" stop-color="#FCFCFB"/></linearGradient>'
      + '<linearGradient id="' + id + 's" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#1F2230" stop-opacity=".12"/><stop offset="1" stop-color="#1F2230" stop-opacity="0"/></linearGradient>'
      + '<radialGradient id="' + id + 'k"><stop offset="0" stop-color="#1F2230" stop-opacity=".22"/><stop offset="1" stop-color="#1F2230" stop-opacity="0"/></radialGradient></defs>';
    var rects = R.map(function (r) {
      return '<g class="okf__mon-g"><rect class="okf__mon" x="' + r.x + '" y="' + r.y + '" width="' + r.w + '" height="' + r.h + '" rx="10"/>'
        + '<line class="okf__diag" x1="' + r.x + '" y1="' + (r.y + r.h) + '" x2="' + (r.x + r.w) + '" y2="' + r.y + '"/></g>';
    }).join('');
    var mx = '<tspan class="okf__lab-k">' + esc(t('max')) + '</tspan> ';
    var nurZoll = !!(AO_L && AO_L.length);
    var labs = R.map(function (q2) {
      var z = String(q2.z).replace('.', ',') + '″';
      if (nurZoll) return '<text class="okf__lab" x="' + q2.lab[5] + '" y="' + q2.lab[6] + '" text-anchor="' + q2.lab[4] + '" style="font-size:' + fs + 'px">' + mx + z + '</text>';
      if (zwei()) {
        var zx = ' x="' + q2.lab[5] + '"';
        return '<text class="okf__lab" x="' + q2.lab[5] + '" y="' + (q2.lab[6] - 1.1 * fs) + '" text-anchor="' + q2.lab[4] + '" style="font-size:' + fs + 'px">'
          + '<tspan' + zx + '>' + mx + z + '</tspan><tspan' + zx + ' dy="' + (1.1 * fs) + '">' + mx + String(kgM).replace('.', ',') + ' kg</tspan></text>';
      }
      var inhalt = mx + z + (!mitKg ? '' : '<tspan class="okf__lab-k"> · </tspan>' + mx + String(kgM).replace('.', ',') + ' kg');
      return '<text class="okf__lab" x="' + q2.lab[5] + '" y="' + q2.lab[6] + '" text-anchor="' + q2.lab[4] + '" style="font-size:' + fs + 'px">' + inhalt + '</text>';
    }).join('');
    return { fy: fy, g: g, vx: Vx, vy: Vy, kgUmriss: schmal && mitKg && !nurZoll, svg: '<svg class="okf__svg" viewBox="' + [Vx, Vy, Vw, Vh].join(' ') + '" preserveAspectRatio="xMidYMid slice" aria-hidden="true">'
      + defs + hinten + '<g>' + rects + '</g><image href="' + esc(bildC.bild) + '" x="0" y="0" width="' + info.w + '" height="' + info.h + '" clip-path="url(#' + id + 'c)"/>'
      + vorn + labs + '</svg>' };
  }

  var buehne = document.createElement('div');
  buehne.className = 'okf__buehne-wrap';
  var AKT = null;
  var AO = D.anordnungen || { sets: {} }, AO_L = null, PIVOT = null, AO_HALTEN = false, AO_ID = 0;
  function aoBild(x) {
    var d = x.d, id = 'okfa' + (++AO_ID);
    if (!d || !x.url) return '';
    return '<svg class="okf__ao-svg" viewBox="' + d.r + '" preserveAspectRatio="xMidYMax meet" aria-hidden="true" focusable="false"><defs><clipPath id="' + id + '-c">' + d.s + '</clipPath>'
      + '<linearGradient id="' + id + '-s" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#2E323C"/><stop offset=".6" stop-color="#181A20"/><stop offset="1" stop-color="#101216"/></linearGradient>'
      + '<linearGradient id="' + id + '-g" x1="0" y1="0" x2=".6" y2=".9"><stop offset="0" stop-color="#FFFFFF" stop-opacity=".09"/><stop offset=".5" stop-color="#FFFFFF" stop-opacity="0"/></linearGradient></defs>'
      + '<image href="' + esc(x.url) + '" x="0" y="0" width="' + d.f[0] + '" height="' + d.f[1] + '" clip-path="url(#' + id + '-c)"/>'
      + x.m.split('@').join(id) + '</svg>';
  }
  function aoListe(c) {
    var sku = c.preset, d = sku && AO.sets[sku], l = [];
    if (d && PRESETS[sku] && PRESETS[sku].bild) {
      var eigen = alle(function (x) { return x.preset === sku && !x.umbau; })[0] || (c.umbau ? null : c);
      d.t.forEach(function (r) {
        var ziel = eigen && r[3] === eigen.anord ? eigen : alle(function (x) { return x.umbau && x.preset === sku && x.anord === r[3]; })[0];
        if (!ziel || presetWeg(ziel)) return;
        l.push({ d: d, url: PRESETS[sku].bild, code: r[0], zoll: r[1], m: r[2], c: ziel, eigen: ziel === eigen && r[0].indexOf('h') < 0 && !!ziel.bild, name: t('ao_' + r[0].replace(/\//g, '_')) });
      });
      return l.length > 1 ? l : [];
    }
    var k = (AO.konf || {})[c.code];
    if (k && c.bild) k.t.forEach(function (r) { l.push({ d: k, url: c.bild, code: r[0], zoll: r[1], m: r[2], c: c, eigen: true, name: t('a_' + c.anord) }); });
    return l;
  }
  function aoHtml(c) {
    var l = aoListe(c);
    AO_L = l;
    PIVOT = null;
    if (!l.length) return '';
    if (!c.bild) { var u = l.filter(function (x) { return x.c === c; })[0]; if (u) PIVOT = u.code; }
    var kg = kgMax(c);
    return '<div class="okf__ao" style="--n: ' + l.length + '">'
      + l.map(function (x) {
        return '<div><b>' + esc(t('bis') + ' ' + x.zoll + '″') + '<span class="visually-hidden">, ' + esc(x.name) + '</span></b>' + aoBild(x) + '</div>';
      }).join('')
      + (kg ? '<p class="okf__ao-kg"><span>' + esc(t('max')) + '</span> <b>' + esc(String(kg).replace('.', ',')) + ' kg</b> <span>' + esc(t('je_monitor')) + '</span>' + gebogenZusatz(c) + '</p>' : '')
      + '</div>';
  }
  function buehneZeichnen(c) {
    AKT = c;
    if (c.zoll && LETZT_ZOLL !== null && c.zoll !== LETZT_ZOLL) PULS = true;
    LETZT_ZOLL = c.zoll || LETZT_ZOLL;
    var bildC = c.bild ? c : aehnlich(c);
    BUEHNE_BILD = (bildC && bildC.bild) || '';
    if (typeof miniSync === 'function') miniSync();
    var tisch = !!(bildC && KOPFPOS[bildC.bildname]), streifen = aoHtml(c);
    var pv = PIVOT && AO_L ? AO_L.filter(function (x) { return x.code === PIVOT && x.c === c; })[0] : null;
    buehne.innerHTML = pv
      ? '<div class="okf__buehne okf__buehne--tisch okf__buehne--ao"><div class="okf__bild">' + aoBild(pv) + '</div>' + streifen + '</div>'
      : '<div class="okf__buehne' + (tisch ? ' okf__buehne--tisch' : '') + '">'
        + (!c.bild && bildC ? '<span class="okf__folgt">' + esc(t('aehnlich')) + '</span>' : '')
        + '<div class="okf__bild" data-okf-bild>' + (!tisch && bildC && bildC.bild ? '<img src="' + esc(bildC.bild) + '" alt="">' : '') + '</div>'
        + (streifen || faktZeile(c, bildC)) + '</div>';
    hoeheSync();
    svgZeichnen();
  }
  function svgZeichnen() {
    var c = AKT, ziel = buehne.querySelector('.okf__buehne--tisch [data-okf-bild]');
    if (!c || !ziel || !buehne.parentNode) return;
    var leiste = buehne.querySelector('.okf__ao');
    ziel.style.bottom = leiste ? (leiste.offsetHeight + leiste.offsetTop - ziel.parentNode.clientHeight + leiste.offsetHeight > 0 ? (ziel.parentNode.clientHeight - leiste.offsetTop + 8) + 'px' : '') : '';
    ziel.setAttribute('data-okf-ao-platz', leiste ? '1' : '');
    var bildC = c.bild ? c : aehnlich(c), r = ziel.getBoundingClientRect();
    var erg = buehneSvg(c, bildC, r.width, r.height);
    if (!erg) return;
    ziel.innerHTML = erg.svg;
    buehne.classList.toggle('is-kg-umriss', !!erg.kgUmriss);
    var fz = buehne.querySelector('.okf__bildfakt');
    if (fz) { fz.style.top = Math.round(Math.min(erg.fy, r.height - 40)) + 'px'; fz.style.bottom = 'auto'; }
    if (PULS) {
      PULS = false;
      requestAnimationFrame(function () {
        ziel.querySelectorAll('.okf__mon-g, .okf__lab').forEach(function (g) { g.classList.add('is-puls'); });
        var f = buehne.querySelector('.okf__bildfakt b'); if (f) f.classList.add('is-puls');
      });
    }
  }
  var BMASS = '';
  function hoeheSync() {
    var el = buehne.querySelector('.okf__buehne');
    if (!el || !buehne.parentNode) return false;
    var wr = buehne.parentNode.getBoundingClientRect(), sc = document.querySelector('.page-wrapper');
    var oben = wr.top + (sc ? sc.scrollTop : 0) + window.scrollY + (parseFloat(getComputedStyle(buehne).paddingTop) || 0);
    buehne.style.setProperty('--okf-oben', Math.round(oben) + 'px');
    var r = el.getBoundingClientRect(), m = Math.round(r.width) + 'x' + Math.round(r.height);
    if (m === BMASS) return false;
    BMASS = m; return true;
  }


  function anordWort(st) {
    var anz = st.n > 1 ? t('monitor_n', { n: st.n }) : t('monitor_1');
    var wie = (st.a === 'triple_pyramid' || st.a === 'quad_pyramid') ? t('a_' + st.a) : (T['k_' + st.a] ? t('k_' + st.a) : '');
    return [anz, wie];
  }
  function klartitel(c) {
    if (c.preset && !c.umbau && PRESETS[c.preset] && PRESETS[c.preset].kopf) return PRESETS[c.preset].kopf;
    var K = D.klartitel || {}, n = anzahl(c.anord), anz = n > 1 ? t('monitor_n', { n: n }) : t('monitor_1');
    var gross = String(K.vorlage || '').split('[art]').join(K.art || '').split('[anzahl]').join(anz);
    if (K.klein) gross = gross.charAt(0).toUpperCase() + gross.slice(1).toLowerCase();
    var arm = t('kt_' + c.arm);
    if (arm && c.kopf === 'slider') arm = t('kt_slider', { t: arm });
    var grau = [K.marke, T['kt_' + c.anord] ? t('kt_' + c.anord) : '', arm, t('kt_' + c.aufbau)].filter(Boolean)
      .map(function (x) { return esc(x).replace(/ /g, '&nbsp;'); }).join(' · ');
    return '<h2 class="one-titel__h1 one-titel__h1--zwei"><span class="one-titel__setup">' + esc(gross)
      + '</span><span class="one-titel__trenner"> · </span><span class="one-titel__marke">' + grau + '</span></h2>';
  }
  function kopfZeichnen(c) {
    var chips = [];
    if (c.zoll) chips.push(t('bis') + ' ' + String(c.zoll).replace('.', ',') + '″');
    var kg = kgText(c);
    if (kg) chips.push(kg);
    if (c.tisch && c.tisch[1]) chips.push(t('tisch_kurz') + ' ' + c.tisch[0] + '–' + c.tisch[1] + ' mm');
    var um = c.umbau && PRESETS[c.preset] ? '<p class="okf__hinweis">' + esc(t('umbau')) + ' <a href="' + esc(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + PRESETS[c.preset].handle) + '">' + esc(t('umbau_link')) + '</a></p>' : '';
    wurzel.querySelector('[data-okf-kopf]').innerHTML = klartitel(c)
      + (chips.length ? '<p class="one-ew__chips">' + chips.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</p>' : '') + um;
  }

  function schritteZeichnen(c) {
    var st = ST;
    var aw = anordWort(st), anz = aw[0], wie = aw[1];
    var h = schritt(pikto(st.a), t('schritt_mon_anord'), anz + (wie ? ' · ' + wie : ''),
      '<div class="okf__feld">'
      + unterpunkt(t('unter_anzahl'), reiterzeile([1, 2, 3, 4].map(function (n) { return reiter('n', n, n > 1 ? t('monitor_n', { n: n }) : t('monitor_1')); }).join(''), t('unter_anzahl')))
      + unterpunkt(t('schritt_anordnung'), '<div class="okf__karten">' + ANORD.filter(function (x) { return x[1] === st.n; })
          .map(function (x) { return karte('a', x[0], t('a_' + x[0]), piktoKarte(x[0])); }).join('') + '</div>')
      + hinweisHtml('n') + '</div>', 'n');
    h += schritt(piktoAufbau(st.b), t('schritt_aufbau'), t('b_' + st.b),
      umschalter(AUFBAU.map(function (b) { return taste('b', b, t('b_' + b), t('b_' + b + '_info')); }).join(''), 3) + hinweisHtml('b'), 'b');
    var i = SYS.indexOf(st.sys), x = ((i + 0.5) / SYS.length * 100).toFixed(2) + '%';
    h += schritt(piktoArm(armVon(st.sys, st.gel)), t('schritt_arm'),
      t('sys_' + st.sys) + ' · ' + (st.gel === '0' ? t('gel_0_kurz') : t('gel_' + st.gel)) + ' · ' + t('kopf_wort') + ' ' + t('kopf_' + st.k),
      unterpunkt(t('unter_system'), umschalter(SYS.map(function (sy) { return taste('sys', sy, t('sys_' + sy), t('sys_' + sy + '_info')); }).join(''), 3)
        + '<div class="okf__feld okf__feld--spitze" style="--x:' + x + '">'
        + unterpunkt(t('unter_ausladung'), reiterzeile(GEL.map(function (g) { return reiter('gel', g, t('gel_' + g)); }).join(''), t('unter_ausladung')))
        + unterpunkt(t('unter_kopf'), reiterzeile(KOEPFE.map(function (k) { return reiter('k', k, t('kopf_' + k)); }).join(''), t('unter_kopf'))
          + hinweisHtml('arm'))
        + '</div>'), 'arm');
    var ziel = wurzel.querySelector('[data-okf-schritte]');
    ziel.innerHTML = h;
    VORHER_OFFEN = OFFEN;
    requestAnimationFrame(function () {
      ziel.querySelectorAll('.okf__schritt').forEach(function (z) { z.classList.toggle('is-dreh', z.getAttribute('data-schritt') === OFFEN); });
    });
  }

  var ZUB = [];
  var oz = wurzel.querySelector('[data-oz]');
  var SETUP_STAFFEL = [[1, 25], [2, 30], [4, 33]];
  function setupSatz(sl) {
    var n = 0, satz = 0;
    ['FG-H01', 'FG-H02', 'FG-H03'].forEach(function (s) { n += sl[s] || 0; });
    SETUP_STAFFEL.forEach(function (st) { if (n >= st[0]) satz = st[1]; });
    return satz;
  }
  function aufNeun(x) { return Math.floor((x + 1) / 10 + 0.5) * 10 - 1; }
  function istSetup(sl) {
    var hat = function (l) { return l.some(function (s) { return sl[s] > 0; }); };
    return hat(['FG-BPS', 'FG-BPL', 'FG-SMB', 'FG-DMB']) && hat(['FG-H01', 'FG-H02', 'FG-H03']);
  }
  function summe(c) {
    var voll = 0, gespart = 0, stueck = 1, rabatt = null, teile = 0;
    if (c.preset) {
      var p = PRESETS[c.preset], pr = p.preis / 100, vg = (p.vergleich || 0) / 100;
      voll = Math.max(pr, vg); gespart = (vg > pr ? vg - pr : 0) + rabattEuro(p.rabatt, pr);
      if (rabattEuro(p.rabatt, pr) > 0) rabatt = p.rabatt;
    } else {
      for (var tl in c.stueckliste) {
        var k = KOMP[tl], n = c.stueckliste[tl];
        if (!k) continue;
        voll += k.preis / 100 * n; gespart += rabattEuro(k.rabatt, k.preis / 100) * n;
        if (!rabatt && rabattEuro(k.rabatt, k.preis / 100) > 0) rabatt = k.rabatt;
      }
      if (istSetup(c.stueckliste)) {
        voll = aufNeun(voll * (100 - setupSatz(c.stueckliste)) / 100);
        gespart = !rabatt ? 0 : rabatt.art === 'prozent' ? Math.floor(Math.round(voll * 100) * Number(rabatt.wert) / 100) / 100 : rabattEuro(rabatt, voll);
      }
    }
    for (var t2 in (c.stueckliste || {})) {
      var k2 = KOMP[t2]; if (!k2) { teile = 0; break; }
      teile += (k2.preis / 100 - rabattEuro(k2.rabatt, k2.preis / 100)) * c.stueckliste[t2];
    }
    ZUB.forEach(function (z) { stueck += z.anzahl; });
    return { voll: voll, betrag: voll - gespart, gespart: gespart, stueck: stueck, rabatt: rabatt, teile: teile };
  }
  function lagerzeile(c) {
    var lz = wurzel.querySelector('[data-fn-lgz]'), zeile = wurzel.querySelector('[data-fn-log]');
    if (!lz || !zeile) return;
    var html = '';
    if (c.preset) html = PRESETS[c.preset].lgz || '';
    else {
      var teile = Object.keys(c.stueckliste).map(function (s) { return KOMP[s]; }).filter(Boolean);
      var aus = teile.filter(function (k) { return !k.da; });
      if (aus.length) html = '<p class="lgz lgz--vor usp__lgz"><span class="lgz__punkt" aria-hidden="true"></span><span class="lgz__text">' + esc(t('teile_ohne_termin')) + '</span></p>';
      else {
        var vor = teile.filter(function (k) { return /lgz--(vor|ab|mto)/.test(k.lgz || ''); })[0];
        html = (vor || teile[0] || {}).lgz || '';
      }
    }
    if (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var neu = tmp.firstElementChild;
      if (neu) { neu.setAttribute('data-fn-lgz', ''); lz.replaceWith(neu); }
    }
    zeile.style.display = '';
  }
  function gruendeZeichnen(c) {
    var l = wurzel.querySelector('[data-okf-gruende]');
    if (!l) return;
    var p = c.preset ? PRESETS[c.preset] : null, g = p && p.gruende && p.gruende.length ? p.gruende : null;
    if (!g) {
      var n = anzahl(c.anord), basis = c.aufbau === 'basis';
      g = ['metall', 'garantie', basis ? (n === 1 ? 'erweiterbar_basis' : 'system') : (n < 4 ? 'erweiterbar' : 'system'),
        String(c.arm).indexOf('feder') === 0 ? 'feder' : 'system'];
    }
    l.querySelectorAll('[data-okg]').forEach(function (e) { e.hidden = g.indexOf(e.getAttribute('data-okg')) < 0; });
  }
  function merkmaleZeichnen(c) {
    var ziel = wurzel.querySelector('[data-okf-nutzen]'), M = D.merkmale || {};
    if (window.opvMerkmale) window.opvMerkmale(c.arm.indexOf('feder') === 0, c.kopf === 'slider');
    if (!ziel) return;
    if (!ziel.firstElementChild) {
      var q = document.querySelector('.one-nutzen__zeilen');
      if (q && !wurzel.contains(q)) ziel.appendChild(q.cloneNode(true));
    }
    var bsp = ziel.querySelector('[data-one-nutzen-bsp]');
    var l = c.arm.indexOf('feder') === 0 ? ['montage', 'hoehe', 'vesa'] : ['montage', 'vesa'];
    if (bsp) bsp.textContent = l.map(function (m) { return M[m]; }).filter(Boolean).join(' · ');
  }
  function rabattEtikett(r) {
    var rb = r.rabatt;
    if (!rb || !rb.titel) return '<span class="vorteil-etikett vorteil-etikett--sparst">'
      + esc((wurzel.getAttribute('data-okf-wort-sparst') || 'Du sparst %s').replace('%s', geld(r.gespart))) + '</span>';
    var wert = rb.art === 'prozent' ? '−' + Math.round(Number(rb.wert)) + ' %' : '−' + geld(Number(rb.wert));
    return '<span class="one-rabatt-zeile"><span class="rabatt-uhr"><span class="vorteil-etikett' + (rb.aktion ? ' vorteil-etikett--aktion' : '') + '">'
      + esc(wert + (rb.aktion ? '' : ' ' + rb.titel)) + '</span>'
      + (rb.ende ? '<span class="rabatt-countdown rabatt-countdown--anhang" role="timer" data-form="anhang" data-rabatt-ende-iso="' + esc(rb.ende) + '"></span>'
        + '<span class="rc-bis" data-rc-bis-iso="' + esc(rb.ende) + '"></span>' : '')
      + '</span></span>';
  }
  function setupPreisZeichnen(r) {
    var pp = wurzel.querySelector('.okf__preis'), tn = pp && pp.querySelector('.tax-note');
    if (!tn) return;
    var sp = tn.querySelector('.osp');
    if (!sp) {
      sp = document.createElement('span'); sp.className = 'osp';
      sp.innerHTML = '<span class="osp__pt" aria-hidden="true">·</span>' + esc(wurzel.getAttribute('data-okf-wort-setuppreis') || '')
        + '<button class="fck__vf-i osp__i" type="button" data-fenster-auf="one-setup-preis" aria-haspopup="dialog" aria-label="'
        + esc(wurzel.getAttribute('data-okf-wort-setupmehr') || '') + '">i</button>';
      var vsh = tn.querySelector('.vsh'); tn.insertBefore(sp, vsh || null);
    }
    sp.hidden = !(r.teile > r.betrag + 0.004);
    sp.querySelector('button').setAttribute('data-osp-betrag', geld(r.teile));
  }
  function kaufboxZeichnen(c) {
    var r = summe(c);
    merkmaleZeichnen(c);
    wurzel.querySelector('[data-okf-preis]').innerHTML = '<div class="price__sale">'
      + '<span class="price-item__group"><span class="price-item--sale price">' + esc(geld(r.betrag)) + '</span></span>'
      + (r.gespart > 0.004
         ? '<span class="price-item__group"><span class="price-item--regular compare-at-price">' + esc(geld(r.voll)) + '</span></span>'
           + rabattEtikett(r)
         : '') + '</div>';
    if (window.rabattCountdown) window.rabattCountdown();
    var knopf = wurzel.querySelector('.okf__kauf');
    if (knopf) {
      var ziel = null;
      knopf.querySelectorAll('span').forEach(function (sp) { if (!ziel && !sp.children.length && sp.textContent.trim()) ziel = sp; });
      if (ziel) {
        var vor = c.preset ? !!PRESETS[c.preset].vor
          : Object.keys(c.stueckliste).some(function (s2) { return KOMP[s2] && KOMP[s2].vor; });
        var basis = wurzel.getAttribute(vor ? 'data-okf-wort-vor' : 'data-okf-wort-kauf') || ziel.textContent.trim();
        ziel.textContent = (r.stueck > 1 && ZUB.length) ? (wurzel.getAttribute('data-okf-wort-korb') || '%d').replace('%d', r.stueck) : basis;
      }
      knopf.disabled = false;
    }
    lagerzeile(c);
    gruendeZeichnen(c);
    leisteFuellen(c, r);
    if (feld && !feld.hidden) document.dispatchEvent(new CustomEvent('3idee:auswahlpreis', { detail: { cent: Math.round(r.betrag * 100) } }));
  }
  if (oz) oz.addEventListener('oz:auswahl', function (e) { ZUB = (e.detail && e.detail.teile) || []; var c = ZWANG || roh(ST); if (c) kaufboxZeichnen(c); });

  function menge() {
    var f = wurzel.querySelector('.okf__knopfzeile input[name="quantity"], .okf__knopfzeile input[type="number"]');
    return Math.max(1, parseInt(f && f.value, 10) || 1);
  }
  function legen(e) {
    e.preventDefault(); e.stopImmediatePropagation();
    var c = ZWANG || roh(ST);
    if (!c || !window.WarenkorbLegen) return;
    var q = menge(), posten = [];
    if (c.preset) {
      var p = PRESETS[c.preset], it = { id: p.id, quantity: q };
      if (p.plan) it.selling_plan = p.plan;
      posten.push(it);
    } else {
      var nm = name(c), kennung = 'K-' + c.code + '-' + Date.now().toString(36);
      var bild = (c.bild || (aehnlich(c) || {}).bild || '');
      if (bild.indexOf('//') === 0) bild = 'https:' + bild;
      Object.keys(c.stueckliste).forEach(function (s) {
        var k = KOMP[s]; if (!k) return;
        var it2 = { id: k.id, quantity: c.stueckliste[s] * q,
                    properties: { _one_setup: kennung, _one_setup_name: nm, _one_setup_bild: bild, _one_setup_code: c.code } };
        if (k.plan) it2.selling_plan = k.plan;
        posten.push(it2);
      });
    }
    ZUB.forEach(function (z) { var i = { id: z.variante, quantity: z.anzahl }; if (z.plan) i.selling_plan = z.plan; posten.push(i); });
    var knopf = wurzel.querySelector('.okf__kauf'), fehler = wurzel.querySelector('[data-okf-fehler]');
    if (knopf) knopf.disabled = true;
    if (fehler) fehler.hidden = true;
    window.WarenkorbLegen(posten, function (gut, grundText) {
      if (knopf) knopf.disabled = false;
      if (!gut && fehler) { fehler.textContent = grundText || ''; fehler.hidden = !grundText; }
    });
  }
  var kaufKnopf = wurzel.querySelector('.okf__kauf');
  if (kaufKnopf) kaufKnopf.addEventListener('click', legen, true);

  var leiste = wurzel.querySelector('[data-okf-leiste]');
  if (leiste) {
    document.body.appendChild(leiste);
    leiste.querySelector('[data-okf-leiste-kauf]').addEventListener('click', legen);
  }
  function leisteFuellen(c, r) {
    if (!leiste) return;
    leiste.querySelector('[data-okf-leiste-titel]').textContent = name(c);
    leiste.querySelector('[data-okf-leiste-preis]').innerHTML = '<div class="price__container"><span class="price">' + esc(geld(r.betrag)) + '</span>'
      + (r.gespart > 0.004 ? ' <span class="compare-at-price">' + esc(geld(r.voll)) + '</span>' : '') + '</div>';
    var w = leiste.querySelector('[data-okf-leiste-wort]'), k = wurzel.querySelector('.okf__kauf');
    var vor = c.preset ? !!(PRESETS[c.preset] || {}).vor : Object.keys(c.stueckliste).some(function (s2) { return KOMP[s2] && KOMP[s2].vor; });
    var wort = wurzel.getAttribute(vor ? 'data-okf-wort-vor' : 'data-okf-wort-kauf') || '';
    if (w && wort) { w.textContent = wort; leiste.querySelector('[data-okf-leiste-kauf]').setAttribute('aria-label', wort); }
  }
  var pd = wurzel.closest('.product-details');
  var BLATT = { an: false, unten: false, tief: 0, griff: null, zug: null, gezogen: 0, vorlauf: 0, platz: null };
  function blattPlatz() {
    if (BLATT.platz) return BLATT.platz;
    var d = document.createElement('div');
    d.className = 'okf-blatt__vorlauf'; d.setAttribute('aria-hidden', 'true');
    BLATT.platz = d;
    return d;
  }
  function tiefJetzt() { return Math.max(0, BLATT.tief - Math.max(0, BLATT.vorlauf - pd.scrollTop)); }
  function blattGriff() {
    if (BLATT.griff) return BLATT.griff;
    var g = document.createElement('button');
    g.type = 'button'; g.className = 'okf-blatt__griff';
    g.setAttribute('aria-label', t('blatt'));
    g.setAttribute('aria-expanded', 'true');
    g.innerHTML = '<span class="okf-blatt__strich" aria-hidden="true"></span><span class="svg-wrapper icon-caret okf-blatt__pf" aria-hidden="true">' + (D.caret || '') + '</span>';
    g.addEventListener('click', function () {
      if (Date.now() - BLATT.gezogen < 350) return;
      blattStellen(!BLATT.unten);
    });
    g.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      BLATT.zug = { y: e.clientY, basis: BLATT.unten ? tiefJetzt() : 0, d: 0, s0: pd.scrollTop };
      try { g.setPointerCapture(e.pointerId); } catch (x) {}
    });
    g.addEventListener('pointermove', function (e) {
      var z = BLATT.zug; if (!z) return;
      z.d = e.clientY - z.y;
      if (Math.abs(z.d) < 6) return;
      if (!BLATT.unten && z.d < 0) { z.hoch = true; pd.scrollTop = z.s0 - z.d; return; }
      pd.classList.add('is-zieh');
      pd.style.setProperty('--okf-blatt-y', Math.max(0, Math.min(tiefJetzt(), z.basis + z.d)) + 'px');
    });
    function los() {
      var z = BLATT.zug; BLATT.zug = null;
      if (!z) return;
      pd.classList.remove('is-zieh');
      if (Math.abs(z.d) < 6) return;
      if (z.hoch) { BLATT.gezogen = Date.now(); return; }
      BLATT.gezogen = Date.now();
      blattStellen(Math.abs(z.d) > 40 ? z.d > 0 : BLATT.unten);
    }
    g.addEventListener('pointerup', los);
    g.addEventListener('pointercancel', los);
    BLATT.griff = g;
    return g;
  }
  function abbildung(ziel, s) {
    if (!s) return null;
    var vb = s.viewBox.baseVal, r = ziel.getBoundingClientRect();
    return { g: r.width / vb.width, x: vb.x, y: vb.y, l: r.left, t: r.top };
  }
  function abbildZu(a, b) {
    var k = b.g / a.g;
    return 'translate(' + ((b.l - a.l) + (a.x - b.x) * b.g) + 'px,' + ((b.t - a.t) + (a.y - b.y) * b.g) + 'px) scale(' + k + ')';
  }
  var GROSS_T = 0;
  function buehneGross(an) {
    var el = buehne.querySelector('.okf__buehne--tisch'), ziel = el && el.querySelector('[data-okf-bild]');
    if (!el || !ziel || an === GROSS) return;
    var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var s0 = ziel.querySelector('.okf__svg'), a0 = abbildung(ziel, s0);
    clearTimeout(GROSS_T);
    if (an) {
      BLATT.hKlein = el.offsetHeight;
      GROSS = true;
      el.style.height = Math.max(BLATT.hKlein, Math.round(BLATT.oben + BLATT.tief - 12 - el.getBoundingClientRect().top)) + 'px';
      hoeheSync(); svgZeichnen();
      var s1 = ziel.querySelector('.okf__svg'), a1 = abbildung(ziel, s1);
      if (ruhig || !a0 || !a1) return;
      s1.style.transformOrigin = '0 0';
      s1.style.transform = abbildZu(a1, a0);
      s1.getBoundingClientRect();
      s1.style.transition = 'transform .3s cubic-bezier(.2, .8, .2, 1)';
      s1.style.transform = '';
    } else {
      GROSS = false;
      var fertig = function () { el.style.height = ''; hoeheSync(); svgZeichnen(); };
      if (ruhig || !a0) { fertig(); return; }
      var r = ziel.getBoundingClientRect(), c = AKT, bildC = c && (c.bild ? c : aehnlich(c));
      var erg = c && buehneSvg(c, bildC, r.width, r.height - (el.offsetHeight - BLATT.hKlein));
      if (!erg) { fertig(); return; }
      s0.style.transformOrigin = '0 0';
      s0.style.transition = 'transform .3s cubic-bezier(.2, .8, .2, 1)';
      s0.style.transform = abbildZu(a0, { g: erg.g, x: erg.vx, y: erg.vy, l: r.left, t: r.top });
      GROSS_T = setTimeout(fertig, 320);
    }
  }
  function blattStellen(unten) {
    BLATT.unten = !!unten;
    if (BLATT.an) buehneGross(BLATT.unten);
    document.documentElement.classList.toggle('okf-blatt-unten', BLATT.unten);
    pd.style.setProperty('--okf-blatt-y', (BLATT.unten ? tiefJetzt() : 0) + 'px');
    if (BLATT.griff) BLATT.griff.setAttribute('aria-expanded', BLATT.unten ? 'false' : 'true');
    Array.prototype.forEach.call(pd.children, function (el) { if (el !== BLATT.griff && el !== BLATT.platz) el.inert = BLATT.unten; });
  }
  function blattMass() {
    var vh = window.innerHeight, el = buehne.querySelector('.okf__buehne') || buehne, b = el.getBoundingClientRect();
    var hb = GROSS ? (BLATT.hKlein || b.height) : b.height;
    var oben = Math.round(Math.min(b.top + window.scrollY + hb * 0.5, vh * 0.45) - vh * 0.065);
    BLATT.oben = oben;
    var fuss = leiste ? (leiste.offsetHeight || 72) : 0, griff = (BLATT.griff && BLATT.griff.offsetHeight) || 40;
    BLATT.tief = Math.max(0, vh - oben - griff - fuss);
    var unterkante = b.top + window.scrollY + hb + 12;
    BLATT.vorlauf = Math.max(0, Math.round(Math.min(unterkante, vh - griff - fuss - 120) - oben));
    if (BLATT.platz) BLATT.platz.style.height = BLATT.vorlauf + 'px';
    pd.style.setProperty('--okf-blatt-vorlauf', BLATT.vorlauf + 'px');
    pd.style.setProperty('--okf-blatt-oben', oben + 'px');
    pd.style.setProperty('--okf-blatt-h', (vh - oben) + 'px');
    pd.style.setProperty('--okf-blatt-fuss', fuss + 'px');
    pd.style.setProperty('--okf-blatt-y', (BLATT.unten ? tiefJetzt() : 0) + 'px');
    miniSync();
  }
  var BUEHNE_BILD = '', MINI = null;
  function blattHub() {
    if (!BLATT.an || !BLATT.oben) return 0;
    if (BLATT.unten) {
      pd.style.setProperty('--okf-blatt-oben', BLATT.oben + 'px');
      pd.style.setProperty('--okf-blatt-h', (window.innerHeight - BLATT.oben) + 'px');
      BLATT.hub = 0; return 0;
    }
    var kopf = document.querySelector('.header__row--top') || document.querySelector('header-component');
    var kopfUnten = kopf ? Math.max(0, kopf.getBoundingClientRect().bottom) : 0;
    var maxHub = Math.max(0, BLATT.oben - kopfUnten - 8);
    var hub = Math.min(maxHub, Math.max(0, pd.scrollTop - (BLATT.vorlauf || 0) * 0.5));
    pd.style.setProperty('--okf-blatt-oben', (BLATT.oben - hub) + 'px');
    pd.style.setProperty('--okf-blatt-h', (window.innerHeight - BLATT.oben + hub) + 'px');
    BLATT.hub = hub; BLATT.maxHub = maxHub;
    return hub;
  }
  function miniSync() {
    if (!pd) return;
    var hub = blattHub();
    var zeigen = BLATT.an && !BLATT.unten && BUEHNE_BILD && BLATT.maxHub > 0 && hub >= BLATT.maxHub - 2;
    if (!zeigen) document.documentElement.classList.remove('okf-blatt-hoch');
    if (zeigen && !MINI) {
      MINI = document.createElement('button');
      MINI.type = 'button'; MINI.className = 'okf-mini';
      MINI.setAttribute('aria-label', t('ansicht_vorne') || 'Bild');
      MINI.innerHTML = '<img alt="">';
      MINI.addEventListener('click', function () {
        var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        pd.scrollTo({ top: 0, behavior: ruhig ? 'auto' : 'smooth' });
      });
      document.body.appendChild(MINI);
    }
    if (!MINI) return;
    var img = MINI.querySelector('img');
    if (BUEHNE_BILD && img.getAttribute('src') !== BUEHNE_BILD) img.setAttribute('src', BUEHNE_BILD);
    MINI.style.top = ((BLATT.oben || 0) - (BLATT.hub || 0) + 4) + 'px';
    MINI.classList.toggle('is-an', !!zeigen);
    document.documentElement.classList.toggle('okf-blatt-hoch', !!zeigen);
    MINI.inert = !zeigen;
  }
  if (pd) pd.addEventListener('scroll', miniSync, { passive: true });
  function blattSync() {
    if (!pd) return;
    var soll = !!(feld && !feld.hidden && buehne.parentNode && window.innerWidth < 750 && !BLATT.zu);
    var html = document.documentElement;
    if (soll && !BLATT.an) {
      BLATT.an = true; BLATT.unten = false;
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      var sc = document.querySelector('.page-wrapper'); if (sc) sc.scrollTop = 0;
      html.classList.add('okf-blatt-an');
      pd.insertBefore(blattGriff(), pd.firstChild);
      pd.insertBefore(blattPlatz(), pd.firstChild);
      pd.scrollTop = 0;
      blattStellen(false);
      requestAnimationFrame(function () { if (BLATT.an) blattMass(); html.classList.remove('okf-frueh'); });
    } else if (!soll && BLATT.an) {
      BLATT.an = false;
      blattStellen(false);
      if (GROSS) { GROSS = false; var bt = buehne.querySelector('.okf__buehne'); if (bt) bt.style.height = ''; }
      html.classList.remove('okf-blatt-an', 'okf-blatt-unten');
      if (BLATT.griff) BLATT.griff.remove();
      if (BLATT.platz) BLATT.platz.remove();
      ['--okf-blatt-oben', '--okf-blatt-h', '--okf-blatt-fuss', '--okf-blatt-y', '--okf-blatt-vorlauf'].forEach(function (v) { pd.style.removeProperty(v); });
      var okr = wurzel.closest('.okr');
      if (okr && window.innerWidth < 750 && !BLATT.zu) okr.scrollIntoView({ block: 'start' });
    }
    if (BLATT.an) blattMass();
    miniSync();
  }
  function leisteSync() {
    if (BLATT.zu) {
      if (window.scrollY > 200) BLATT.zuWeg = true;
      else if (BLATT.zuWeg && window.scrollY < 4) { BLATT.zu = false; BLATT.zuWeg = false; blattSync(); }
    }
    if (!leiste) return;
    var zeile = wurzel.querySelector('.okf__knopfzeile');
    var zr = zeile ? zeile.getBoundingClientRect() : null;
    var an = BLATT.an || !!(feld && !feld.hidden && zr && window.innerWidth < 1024 && zr.bottom < 0);
    if ((leiste.getAttribute('data-stuck') === 'true') === an) return;
    leiste.setAttribute('data-stuck', an ? 'true' : 'false');
    leiste.inert = !an;
  }

  document.addEventListener('one:konfigurieren', function (e) {
    var h = String((e.detail && e.detail.ziel) || '').split('+')[0];
    if (!h || !ST) return;
    var sku = null;
    for (var s in PRESETS) if (PRESETS[s] && PRESETS[s].handle === h) { sku = s; break; }
    var c = sku && alle(function (x) { return x.preset === sku && !x.umbau; })[0];
    if (!c) return;
    ZWANG = null; ST = stVon(c); OFFEN = null; HINWEIS = null; START_FEST = false;
    neu();
  });
  document.addEventListener('okf:anzahl', function (e) {
    var n = e.detail && Number(e.detail.n);
    if (!ST || !n) return;
    ZWANG = null; ST = setze(ST, 'n', n); OFFEN = null; START_FEST = false;
    neu();
    var ziel = wurzel.querySelector('[data-okf-schritte]') || wurzel;
    if (ziel.scrollIntoView) ziel.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
  function neu() {
    if (!ST) return;
    if (!AO_HALTEN) PIVOT = null;
    var c = ZWANG || roh(ST);
    if (!ZWANG && !ok(c) && !(START_FEST && c && !presetWeg(c))) { var nx = naechste(ST); if (nx) { ST = stVon(nx); c = nx; } }
    if (!c) { wurzel.querySelector('[data-okf-schritte]').innerHTML = '<p class="okf__leer">' + esc(t('kein_setup')) + '</p>'; return; }
    kopfZeichnen(c);
    buehneZeichnen(c);
    schritteZeichnen(c);
    if (oz) {
      oz.setAttribute('data-oz-sku', c.preset || '');
      oz.setAttribute('data-oz-anzahl', String(anzahl(c.anord) || ''));
      oz.setAttribute('data-oz-gewicht', String(setupGramm(c)));
      oz.dispatchEvent(new CustomEvent('oz:neu'));
    }
    kaufboxZeichnen(c);
    ansicht();
    konfigMelden();
    grenzePruefen();
    wurzel.dispatchEvent(new CustomEvent('okf:neu'));
  }
  var KONFIG_LETZT;
  function urlSync() {
    if (!window.history || !history.replaceState || !window.URL) return;
    var c = ST ? (ZWANG || roh(ST)) : null, offen = feld ? !feld.hidden : false;
    var u = new URL(location.href), soll = offen && c && c.code ? c.code : null;
    if ((u.searchParams.get('konfig') || null) === soll) return;
    if (soll) u.searchParams.set('konfig', soll); else u.searchParams.delete('konfig');
    try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
  }
  function konfigMelden() {
    urlSync();
    var c = (!feld || !feld.hidden) ? AKT : null;
    if (c && c.preset === D.eigen && !c.umbau) c = null;
    var code = c ? c.code : null;
    if (code === KONFIG_LETZT) return;
    KONFIG_LETZT = code;
    var det = null;
    if (c) {
      var r = (((D.paket || {}).kombinationen) || []).filter(function (x) { return x.code === c.code; })[0] || {};
      var pr = c.preset ? PRESETS[c.preset] : null;
      det = {};
      for (var k in r) det[k] = r[k];
      det.preset = c.umbau ? null : c.preset;
      det.gleiches_set = c.umbau ? c.preset : null;
      det.zoll = c.zoll; det.kg_max = c.kg ? c.kg[1] : null;
      det.preset_zoll = pr && !c.umbau ? pr.zoll || '' : ''; det.preset_kg = c.kg_text || '';
      det.preset_kg_gebogen = pr ? pr.kg_gebogen || '' : ''; det.preset_gewicht_g = pr ? pr.gewicht_g || 0 : 0;
      det.massbild = (D.konfzeichnungen || {})[c.code] || null;
      det.kg_gebogen_max = c.kg_gebogen || null;
      det.preset_bild = (pr && !c.umbau ? pr.bild : c.bild) || '';
      var e0 = alle(function (x) { return x.preset === D.eigen && !x.umbau; })[0];
      det.wie_seite = e0 ? { stange: e0.aufbau === c.aufbau, arme: e0.arm === c.arm && e0.anord === c.anord, kopf: e0.kopf === c.kopf }
        : { stange: false, arme: false, kopf: false };
      det.teile = Object.keys(c.stueckliste).map(function (s) {
        var kp = KOMP[s] || {};
        return { sku: s, anzahl: c.stueckliste[s], titel: kp.titel || s, bild: kp.bild || '' };
      });
    }
    window.oneKonfigAktuell = det;
    document.dispatchEvent(new CustomEvent('3idee:konfig', { detail: det }));
  }
  function ansicht() { if (hoeheSync()) svgZeichnen(); if (BLATT.an) blattMass(); }

  var dlg = document.querySelector('[data-fenster="okf-nm"]'), ausloeser = null;
  function nmKnopf(alt) {
    var bc = alt.bild ? alt : aehnlich(alt), src = bc && bc.bild ? String(bc.bild).replace(/([?&])width=\d+/, '$1width=240') : '';
    var txt = name(alt) + ' · ' + geld(preis(alt));
    return '<button type="button" class="okf__fix' + (src ? ' okf__fix--bild' : '') + '" data-fix="' + esc([alt.anord, alt.aufbau, alt.arm, alt.kopf].join('|'))
      + '" aria-label="' + esc(t('stattdessen') + ': ' + txt) + '">'
      + (src ? '<span class="okf__fix-bild"><img src="' + esc(src) + '" alt="" loading="lazy"></span>' : '<span>' + esc(t('stattdessen')) + '</span> ')
      + '<span class="okf__fix-t">' + esc(txt) + '</span></button>';
  }
  function nmFenster(x, ausl) {
    if (!dlg) return;
    var alt = naechste(x); ausloeser = ausl;
    dlg.querySelector('[data-okf-nm]').innerHTML = '<p class="fnst__frei okf__nm-k">' + esc(t('nicht_moeglich')) + '</p>'
      + '<p class="okf__nm-t">' + esc(grund(x)) + '</p>'
      + (alt ? nmKnopf(alt) : '');
    if (!dlg.open) dlg.showModal();
    var f = dlg.querySelector('.okf__fix'); if (f) f.focus();
  }
  function setupGramm(c) {
    if (c.preset && PRESETS[c.preset] && Number(PRESETS[c.preset].gewicht_g) > 0) return Math.round(Number(PRESETS[c.preset].gewicht_g));
    var g = 0;
    for (var tl in (c.stueckliste || {})) { var k = KOMP[tl]; if (k && Number(k.g) > 0) g += Number(k.g) * c.stueckliste[tl]; }
    return Math.round(g);
  }
  function grenzGruende(c) {
    var g = [], zoll = 0, kg = 0;
    ARB.mon.forEach(function (m) { zoll = Math.max(zoll, m.zoll || 0); kg = Math.max(kg, m.kg || 0); });
    if (zoll && c.zoll && zoll > c.zoll + 0.4) g.push(t('grenze_zoll', { z: String(Math.round(zoll * 10) / 10).replace('.', ','), max: c.zoll }));
    var km = kgMax(c);
    if (kg && km && kg > km) g.push(t('grenze_kg', { kg: String(Math.round(kg * 10) / 10).replace('.', ','), max: km }));
    var kl = Math.min.apply(null, ARB.mon.map(function (m) { return m.kg || Infinity; })), kn = kgMin(c);
    if (kn && isFinite(kl) && kl < kn) g.push(t('grenze_kg_min', { kg: String(Math.round(kl * 10) / 10).replace('.', ','), min: String(kn).replace('.', ',') }));
    var ti = c.tisch || [], mm = ARB.tisch_mm;
    if (mm && ti[1] && (mm > ti[1] || (ti[0] && mm < ti[0]))) g.push(t('grenze_tisch', { mm: mm, von: ti[0] || 0, bis: ti[1] }));
    return g;
  }
  var engineLauf = 0;
  function grenzePruefen() {
    if (!dlg || !feld || !feld.hidden) return;
    var c = alle(function (x) { return x.preset === D.eigen && !x.umbau; })[0];
    if (!c) return;
    var g = grenzGruende(c);
    if (g.length) { grenzeZeigen(g); return; }
    if (!window.SetupUrteil || !ARB.mon.length || anzahl(c.anord) !== ARB.mon.length) return;
    if (!ARB.mon.every(function (m) { return m.zoll || m.kg; })) return;
    var mein = ++engineLauf;
    window.SetupUrteil.hole().then(function (stand) {
      if (mein !== engineLauf) return;
      var f = window.SetupUrteil.fuer(stand, wurzel.getAttribute('data-okf-skus') || D.eigen);
      if (f && f.urteil === 'nein') grenzeZeigen([t('grenze_engine')]);
    }).catch(function () {});
  }
  function grenzeZeigen(g) {
    if (!dlg || !feld || !feld.hidden) return;
    var schluessel = 'okf-grenze:' + D.eigen + ':' + g.join('|');
    try { if (sessionStorage.getItem(schluessel)) return; sessionStorage.setItem(schluessel, '1'); } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    dlg.querySelector('[data-okf-nm]').innerHTML = '<p class="fnst__frei okf__nm-t">' + esc(t('grenze_titel')) + '</p>'
      + g.map(function (x) { return '<p class="okf__nm-u">' + esc(x) + '</p>'; }).join('')
      + '<div class="okf__nm-wege">'
      + '<a class="button okf__nm-weg" href="' + esc(root + 'pages/setup-finder') + '">' + esc(t('grenze_finder')) + '</a>'
      + '<button type="button" class="button button-secondary okf__nm-weg" data-fenster-auf="setup">' + esc(t('grenze_aendern')) + '</button>'
      + '</div>';
    var p = dlg.parentElement;
    if (p && p !== document.body && p.checkVisibility && !p.checkVisibility()) document.body.appendChild(dlg);
    ausloeser = null;
    if (!dlg.open) dlg.showModal();
  }
  function anzahlFenster(n, ausl) {
    if (!dlg) return;
    var e = ARB.mon.length; ausloeser = ausl;
    dlg.querySelector('[data-okf-nm]').innerHTML = '<p class="fnst__frei okf__nm-t">' + esc(t('anzahl_titel', { n: n })) + '</p>'
      + '<p class="okf__nm-u">' + esc(e === 1 ? t('anzahl_angegeben_1') : t('anzahl_angegeben_n', { n: e })) + '</p>'
      + '<div class="okf__nm-wege">'
      + '<button type="button" class="button button-secondary okf__nm-weg" data-fenster-auf="setup">' + esc(e < n ? t('anzahl_weiter') : t('anzahl_aendern')) + '</button>'
      + '<button type="button" class="button button-secondary okf__nm-weg" data-fenster-zu>' + esc(e === 1 ? t('anzahl_bleiben_1') : t('anzahl_bleiben_n', { n: e })) + '</button>'
      + '</div>';
    if (!dlg.open) dlg.showModal();
    var f = dlg.querySelector('.okf__nm-weg'); if (f) f.focus();
  }
  if (dlg) {
    window.addEventListener('click', function (e) {
      if (!dlg.open || !dlg.contains(e.target) || !e.target.closest('[data-fenster-auf]')) return;
      ausloeser = null; dlg.close();
    }, true);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-fenster-zu]')) { dlg.close(); return; }
      var fx = e.target.closest('[data-fix]');
      if (fx && K[fx.dataset.fix]) { ausloeser = null; dlg.close(); OFFEN = null; HINWEIS = null; START_FEST = false; ZWANG = null; ST = stVon(K[fx.dataset.fix]); neu(); }
    });
    dlg.addEventListener('close', function () {
      var a = ausloeser; if (!a) return;
      var ziel = a.isConnected ? a : wurzel.querySelector('button[data-f="' + a.dataset.f + '"][data-w="' + a.dataset.w + '"]');
      if (ziel) ziel.focus();
    });
  }

  wurzel.addEventListener('click', function (e) {
    var sk = e.target.closest('[data-auf]');
    if (sk) { OFFEN = OFFEN === sk.dataset.auf ? null : sk.dataset.auf; schritteZeichnen(roh(ST)); ansicht(); return; }
    var b = e.target.closest('button[data-f]');
    if (!b) return;
    var f = b.dataset.f, w = f === 'n' ? +b.dataset.w : b.dataset.w;
    if (b.getAttribute('aria-disabled') === 'true') {
      if (HINWEIS) { HINWEIS = null; schritteZeichnen(roh(ST)); }
      var ziel = setze(ST, f, w), zn = anzahl(ziel.a);
      if (ARB.mon.length && ARB.mon.length <= 4 && zn && zn !== ARB.mon.length) { anzahlFenster(zn, b); return; }
      nmFenster(ziel, b); return;
    }
    if (['n', 'a', 'sys', 'gel', 'k'].indexOf(f) < 0) OFFEN = null;
    START_FEST = false;
    var vorher = ST;
    var neuSt = setze(ST, f, w);
    if (!ok(roh(neuSt))) { var b2 = besteMit(ST, f, w); if (b2) neuSt = stVon(b2); }
    ZWANG = null; ST = neuSt;
    var cA = roh(vorher), cB = roh(ST), werte = handy() ? grenzHinweis(cA, cB) : [];
    HINWEIS = { wo: f === 'n' || f === 'a' ? 'n' : f === 'b' ? 'b' : 'arm', werte: werte,
      leise: (f === 'gel' && w === '1' && vorher.k === 'standard' && ST.k === 'slider'
        && (ST.a === 'dual_horizontal' || ST.a === 'quad_grid')) ? t('grund_kopf_1gelenk') : '',
      passt: werte.length && ARB.mon.length && cB && !passtGrund(cB) ? t(ARB.mon.length > 1 ? 'wh_passt_n' : 'wh_passt_1') : '' };
    neu();
  });

  var feld = wurzel.closest('[data-okr-feld]');
  var medien = document.querySelector('.product-information__media');
  var versteckt = [];
  var ANZ_LETZT = null;
  function anzahlAngleichen(immer) {
    var e = ARB.mon.length;
    if (!ST || !e || e > 4) { ANZ_LETZT = e || null; return false; }
    var neuZahl = e !== ANZ_LETZT; ANZ_LETZT = e;
    if (!immer && !neuZahl) return false;
    if (ST.n === e) return false;
    ZWANG = null; ST = setze(ST, 'n', e); START_FEST = false;
    return true;
  }
  function reiterSync() {
    var offen = feld && !feld.hidden;
    if (offen && START_FEST && anzahlAngleichen(true)) neu();
    if (!medien) {
      if (offen && !buehne.parentNode) wurzel.insertBefore(buehne, wurzel.firstChild);
      return;
    }
    if (offen) {
      var c0 = ZWANG || roh(ST);
      if (c0) document.dispatchEvent(new CustomEvent('3idee:auswahlpreis', { detail: { cent: Math.round(summe(c0).betrag * 100) } }));
      if (!buehne.parentNode) {
        buehne.style.setProperty('--okf-galh', Math.round(medien.getBoundingClientRect().height) + 'px');
        versteckt = Array.prototype.filter.call(medien.children, function (el) { return el.style.display !== 'none'; });
        versteckt.forEach(function (el) { el.dataset.okfDisplay = el.style.display; el.style.display = 'none'; });
        var gal = medien.querySelector('media-gallery');
        if (gal) buehne.style.setProperty('--okf-abstand-oben', getComputedStyle(gal).paddingTop || '0px');
        medien.appendChild(buehne);
      }
      ansicht(); svgZeichnen();
    } else if (buehne.parentNode) {
      buehne.remove();
      document.dispatchEvent(new CustomEvent('3idee:auswahlpreis', { detail: { cent: 0 } }));
      versteckt.forEach(function (el) { el.style.display = el.dataset.okfDisplay || ''; delete el.dataset.okfDisplay; });
      versteckt = [];
    }
    leisteSync();
    blattSync();
    leisteSync();
    konfigMelden();
  }
  if (feld && window.MutationObserver) new MutationObserver(function () { BLATT.zu = false; BLATT.zuWeg = false; reiterSync(); }).observe(feld, { attributes: true, attributeFilter: ['hidden'] });

  Array.prototype.forEach.call(wurzel.querySelectorAll('[data-okf-technik]'), function (sprung) { sprung.addEventListener('click', function (e) {
    var ziel = document.querySelector(sprung.getAttribute('href'));
    if (!ziel) return;
    e.preventDefault();
    var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var los = function () { ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' }); };
    if (BLATT.an) { BLATT.zu = true; BLATT.zuWeg = false; blattSync(); leisteSync(); requestAnimationFrame(function () { requestAnimationFrame(los); }); }
    else los();
  }); });

  var start = alle(function (c) { return c.preset === D.eigen && !c.umbau; })[0] || alle(ok)[0];
  if (!start) { document.documentElement.classList.remove('okf-frueh'); wurzel.querySelector('[data-okf-schritte]').innerHTML = '<p class="okf__leer">' + esc(t('leer')) + '</p>'; return; }
  ST = stVon(start);
  var URL_KONFIG = null, URL_AUF = false;
  try { var kc = new URL(location.href).searchParams.get('konfig'); if (kc) URL_KONFIG = alle(function (c) { return c.code === kc && ok(c); })[0] || null; URL_AUF = kc === 'start'; } catch (e) {}
  if (URL_KONFIG) { ST = stVon(URL_KONFIG); START_FEST = false; URL_AUF = true; }
  if (!URL_AUF) document.documentElement.classList.remove('okf-frueh');
  arbeitsplatzLesen();
  ANZ_LETZT = ARB.mon.length || null;
  neu();
  reiterSync();
  if (URL_AUF && feld && feld.hidden) {
    var reiterAuf = function () { setTimeout(function () { var r = document.querySelector('[data-okr-r="individuell"]'); if (r && feld.hidden) r.click(); }, 0); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reiterAuf); else reiterAuf();
  }
  document.addEventListener('finder:auswahl', function () { START_FEST = false; arbeitsplatzLesen(); anzahlAngleichen(false); neu(); });
  var warte = 0;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(warte);
    warte = requestAnimationFrame(function () { if (buehne.parentNode) { hoeheSync(); svgZeichnen(); } blattSync(); leisteSync(); });
  });
  document.addEventListener('scroll', leisteSync, { passive: true, capture: true });
  if (window.ResizeObserver) new ResizeObserver(function () { requestAnimationFrame(ansicht); }).observe(wurzel);
  if (window.ResizeObserver) new ResizeObserver(function () { if (BLATT.an) requestAnimationFrame(blattMass); }).observe(buehne);
  window.okfMotor = {
    alle: function () { return Object.keys(ALLE).map(function (k) { return ALLE[k]; }); },
    ok: function (c) { return ok(c); },
    summe: function (c) { return summe(c); },
    waehle: function (code) {
      var c = ALLE[code]; if (!c) return;
      ZWANG = c; ST = stVon(c); OFFEN = null; HINWEIS = null; START_FEST = false; neu();
    },
    aktuell: function () { return ZWANG || (ST ? roh(ST) : null); },
    gueltig: function (c) { return !!c && !presetWeg(c); },
    passt: function (c) { return !passtGroesse(c); },
    monitore: function () { return ARB.mon.slice(); },
    geld: geld,
    eigen: D.eigen, presets: PRESETS, komp: KOMP, anzahl: anzahl, pikto: pikto
  };
  document.dispatchEvent(new CustomEvent('okf:motor'));
})();
(function () {
  function waAdresse(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-okf-wa]') : null;
    if (!a) return;
    try {
      var u = new URL(location.href), k = u.searchParams.get('konfig');
      a.href = a.href.split('?')[0] + '?text=' + encodeURIComponent(a.getAttribute('data-okf-wa') + location.origin + u.pathname + (k ? '?konfig=' + k : ''));
    } catch (err) {}
  }
  document.addEventListener('click', waAdresse, true);
  document.addEventListener('auxclick', waAdresse, true);
})();
